import { Inject, Injectable } from '@angular/core';

import { environment } from 'spotlight-ui/environments/environment';
import { LDClient, LDFlagSet, LDMultiKindContext, LDSingleKindContext } from 'launchdarkly-js-client-sdk';
import { launchDarklyFactory } from './launch-darkly-factory';

export interface LaunchDarklyUserContext extends LDSingleKindContext {
  kind: 'user';
  key: string;
}

export interface LaunchDarklyLocationContext extends LDSingleKindContext {
  kind: 'location';
  key: string;
}

@Injectable()
export class LaunchDarklyService {
  private client: LDClient;
  private initializationPromise: Promise<LDFlagSet>;

  constructor(
    @Inject(launchDarklyFactory) private ldFactory: typeof launchDarklyFactory
  ) { }

  public initializeClient(locationNumber: string, username: string): Promise<LDFlagSet> {
    const locationContext: LaunchDarklyLocationContext = {
      kind: 'location',
      key: locationNumber,
    };

    const userContext: LaunchDarklyUserContext = {
      kind: 'user',
      key: username,
    };

    const multiContext: LDMultiKindContext = {
      kind: 'multi',
      user: userContext,
      location: locationContext,
    };

    this.initializationPromise = (async() => {
      try {
        this.client = this.ldFactory(environment.launchDarklyClientId, multiContext);
        await this.client.waitForInitialization(5);
        const flags = this.client.allFlags();
        return flags;
      } catch (err) {
        console.error('LaunchDarkly initialization failed:', err);
        return {} as LDFlagSet;
      }
    })();

    return this.initializationPromise;
  }
}